import { InviteFunctions } from './invites';
declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build
declare const VERSION: string; // The value is supplied by Webpack during the build
import * as Sentry from '@sentry/browser';
import { CookieFunctions } from './cookiemessage';
declare let gtag: Function;
// import { Integrations } from '@sentry/tracing';
// import { RewriteFrames } from '@sentry/integrations';

if (!IS_DEV_BUILD) {

  Sentry.init({
    dsn: 'https://68dc5a7baeed492e81f53b29c14868e7@o460993.ingest.sentry.io/5462155',
    release: `v-${VERSION}`,
    // integrations: [new Integrations.BrowserTracing()],
    // tracesSampleRate: 0.25,
    // debug: true,
    // beforeSend(event) {
    //  alert('Event!');
    //  console.log(event);
    //  return event;
    // },
  });

} else {

  // Sentry.init({
  //  dsn: 'https://a14734e2f34e483fb65ac3c289bec28e@o460993.ingest.sentry.io/5462176',
  //  release: `v-${VERSION}`,
  //  integrations: [new Integrations.BrowserTracing()],
  //  tracesSampleRate: 1.0,
  // });
}

export class AboutUs {

  public inviteFunctions: InviteFunctions;
  private resizeTask: any = null;
  private resizeListener: any = null;
  public cookieFunctions: CookieFunctions;

  constructor() {
    this.inviteFunctions = new InviteFunctions;
    this.cookieFunctions = new CookieFunctions;
    console.log('About us invoked');
  }

  setupResizeListener() {

    this.resizeListener = () => {

      if (this.resizeTask !== null) {
        clearTimeout(this.resizeTask);
      }

      this.resizeTask = setTimeout(
        () => {
          this.resizeTask = null;
          console.log('Resize!');
        },
        delay);

    };

    const delay = 100;
    window.addEventListener('resize', this.resizeListener.bind(this));

  }

  getCookie(name: String) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  }

  analytics() {
    // only submit to analytics if cookie consent allows it!
    // TODO - test event correctly sent to Analytics if cookie consent
    // and not sent if no consent
    const consentCookie = this.getCookie('cpt-cookie-consent');

    if (!consentCookie || consentCookie.indexOf('-analytics') === -1) {
      return;
    }

    // console.log(window.location);
    // console.log(document.title);

    if (typeof (gtag) !== 'undefined') {
      gtag('js', new Date());
      gtag('config', 'G-PMPJFNGGSE');
      // gtag('event', 'page_view', {
        // page_title: document.title,
        //// page_location: window.location.pathname,
        // page_path: window.location.pathname,
      // });
    }
  }

}

const aboutUsJs = new AboutUs();
// aboutUsJs.inviteFunctions.setupModal();
aboutUsJs.inviteFunctions.setupTrial();
aboutUsJs.inviteFunctions.setupForm();
aboutUsJs.cookieFunctions.setupMessage();
aboutUsJs.inviteFunctions.initialise(false);
aboutUsJs.setupResizeListener();
aboutUsJs.analytics();
